import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'
import { useContext, useCallback } from 'react'

export const useMessage = () => {
  const worldReady = useContext(WorldReadyContext)

  const getMessage = useCallback(
    (messageId, data) => {
      if (data) {
        return new MessageFormat(worldReady, { id: messageId }).format(data)
      }
      return new MessageFormat(worldReady, { id: messageId }).format()
    },
    [worldReady],
  )

  return { getMessage }
}
